import highcharts from 'highcharts'
import highchartsMore from 'highcharts-more'
import Scroll from '../javascripts/scroll'

highchartsMore(highcharts)

document.addEventListener('DOMContentLoaded', () => {
  const createChart = element => {
    const data = JSON.parse(element.dataset.value)
    const options = {
      chart: {
        renderTo: element,
        polar: true,
        type: 'area',
        spacing: [4, 0, 0, 0],
        backgroundColor: 'transparent',
      },
      pane: {
        size: '100%',
      },
      title: {
        text: '',
      },
      xAxis: {
        // デザインの再現を優先しhtml/cssで配置するため空で指定。
        categories: ['', '', '', '', '', '', '', '', ''],
        lineWidth: 0,
        gridLineWidth: 0,
        tickmarkPlacement: 'on',
      },
      yAxis: {
        labels: {
          enabled: false,
        },
        gridLineInterpolation: 'polygon',
        gridLineWidth: 0,
        lineWidth: 0,
        min: 0,
        max: 5,
      },
      tooltip: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        series: {
          enableMouseTracking: false,
          lineWidth: 0,
          pointPlacement: 'on',
        },
      },
      series: [
        {
          color: '#00A394',
          data: [
            parseFloat(data[0]),
            parseFloat(data[1]),
            parseFloat(data[2]),
            parseFloat(data[3]),
            parseFloat(data[4]),
          ],
          fillOpacity: 0.5,
        },
      ],
    }
    new highcharts.Chart(options)
  }

  const chartElement = document.getElementById('js-company-radar')
  if (chartElement) {
    Scroll.scrollInViewElement(chartElement, createChart)
  }
})
